var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdleTimeoutInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 0.875C26.8906 0.875 0.875 26.8906 0.875 59C0.875 91.1094 26.8906 117.125 59 117.125C91.1094 117.125 117.125 91.1094 117.125 59C117.125 26.8906 91.1094 0.875 59 0.875ZM59 105.875C32.9844 105.875 12.125 85.0156 12.125 59C12.125 33.2188 32.9844 12.125 59 12.125C84.7812 12.125 105.875 33.2188 105.875 59C105.875 85.0156 84.7812 105.875 59 105.875ZM73.2969 81.5C74.7031 82.4375 76.3438 82.2031 77.2812 80.7969L81.7344 74.9375C82.6719 73.5312 82.4375 71.8906 81.0312 70.9531L65.5625 59.4688V26.1875C65.5625 24.7812 64.1562 23.375 62.75 23.375H55.25C53.6094 23.375 52.4375 24.7812 52.4375 26.1875V64.8594C52.4375 65.5625 52.6719 66.5 53.375 66.9688L73.2969 81.5Z",
    fill: "#516393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdleTimeoutInactive);
export default __webpack_public_path__ + "static/media/idle-timeout-inactive.71f569c50453ccf28038c6b7fe4d1e2d.svg";
export { ForwardRef as ReactComponent };